(function(){
    var root = document.getElementById('sec-recenzja');
    if (!root || root.dataset.lpReviewInit) return;
    root.dataset.lpReviewInit = '1';
    var toggle = root.querySelector('[data-review-toggle]');
    var body   = root.querySelector('[data-review-form-body]');
    if (toggle && body) {
      toggle.addEventListener('click', function(){
        var open = body.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Stars
    var stars = root.querySelectorAll('[data-star]');
    var ratingInput = root.querySelector('[data-review-rating]');
    stars.forEach(function(btn){
      btn.addEventListener('click', function(){
        var val = parseInt(btn.getAttribute('data-star'), 10);
        if (ratingInput) ratingInput.value = val;
        stars.forEach(function(b){ b.classList.toggle('is-filled', parseInt(b.getAttribute('data-star'),10) <= val); });
      });
    });
    // File upload preview (cosmetic — note: Shopify /contact nepřenáša súbory)
    var fileInput = root.querySelector('[data-review-file]');
    var uploadArea = root.querySelector('[data-review-upload]');
    if (fileInput && uploadArea) {
      var files = [];
      var uploadBtn = uploadArea.querySelector('.lp-review__upload-btn');
      function render(){
        uploadArea.querySelectorAll('.lp-review__preview').forEach(function(el){ el.remove(); });
        files.forEach(function(f, idx){
          var wrap = document.createElement('div'); wrap.className = 'lp-review__preview';
          var media = f.type.indexOf('video/') === 0 ? document.createElement('video') : document.createElement('img');
          media.src = f.data; media.className = 'lp-review__preview-media'; if (media.tagName === 'VIDEO') media.muted = true;
          wrap.appendChild(media);
          var rm = document.createElement('button'); rm.type = 'button'; rm.className = 'lp-review__preview-remove'; rm.innerHTML = '×';
          rm.addEventListener('click', function(){ files.splice(idx,1); render(); });
          wrap.appendChild(rm);
          uploadArea.insertBefore(wrap, uploadBtn);
        });
        uploadBtn.style.display = files.length >= 3 ? 'none' : '';
      }
      fileInput.addEventListener('change', function(){
        var list = Array.prototype.slice.call(fileInput.files);
        if (files.length + list.length > 3) { alert('Maksymalnie 3 pliki.'); fileInput.value=''; return; }
        list.forEach(function(file){
          if (file.size > 5*1024*1024) { alert('Plik ' + file.name + ' przekracza 5 MB.'); return; }
          var reader = new FileReader();
          reader.onload = function(ev){ files.push({ data: ev.target.result, type: file.type }); render(); };
          reader.readAsDataURL(file);
        });
        fileInput.value = '';
      });
    }
    // AJAX submit
    var form = document.getElementById('lp-review-form');
    if (form) {
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var submit = form.querySelector('.lp-review__submit');
        if (submit) { submit.disabled = true; submit.textContent = 'Wysyłanie...'; }
        fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' } })
          .then(function(){
            var card = root.querySelector('.lp-review');
            card.innerHTML = '<div class="lp-review__success"><strong>Dziękujemy za recenzję! 🎁</strong>Twoja opinia trafiła do nas — wkrótce wyślemy Ci małą niespodziankę.</div>';
          })
          .catch(function(){
            if (submit) { submit.disabled = false; submit.textContent = 'Invia recensione'; }
            alert('Coś poszło nie tak. Spróbuj ponownie lub napisz do nas.');
          });
      });
    }
  })();

/* == doplnené zo sekcie lp-pour-product-it.liquid == */
(function() {
  // ═══════════════════════════════════════════
  //  lp-pour-product-it — single-variant page logic
  // ═══════════════════════════════════════════
  const variantIn   = document.getElementById('lp-variant-id');
  const qtyInput    = document.getElementById('lp-qty-input');
  const qtyVal      = document.getElementById('lp-qty-val');
  const qtyMinus    = document.getElementById('lp-qty-minus');
  const qtyPlus     = document.getElementById('lp-qty-plus');
  const addBtn      = document.getElementById('lp-add-btn');
  const buyBtn      = document.getElementById('lp-buy-btn');
  const heroForm    = document.getElementById('lp-product-form');
  const stickyBar   = document.getElementById('lp-sticky');
  const stickyBtn   = document.getElementById('lp-sticky-btn');
  const mainImgEl   = document.getElementById('lp-main-img');

  function lpCurrentVid() { return variantIn ? parseInt(variantIn.value, 10) : null; }
  let quantity = 1;

  // ── QTY STEPPER ──
  function setQty(n) {
    quantity = Math.max(1, Math.min(999, n));
    if (qtyVal.tagName === 'INPUT') qtyVal.value = quantity; else qtyVal.textContent = quantity;
    qtyInput.value = quantity;
  }
  if (qtyMinus) qtyMinus.addEventListener('click', () => setQty(quantity - 1));
  if (qtyPlus)  qtyPlus.addEventListener('click', () => setQty(quantity + 1));

  /* lp-qty-editable — množstvo sa dá napísať, nielen naklikať.
     #lp-qty-val je v sekciách <input>; staršie sekcie mali <span>, preto vieme oboje. */
  (function () {
    if (!qtyVal) return;
    var jeInput = qtyVal.tagName === 'INPUT';
    if (jeInput) {
      qtyVal.setAttribute('maxlength', '4');
    } else {
      qtyVal.setAttribute('contenteditable', 'true');
      qtyVal.setAttribute('inputmode', 'numeric');
      qtyVal.style.outline = 'none';
      qtyVal.style.minWidth = '2.2em';
    }
    function citaj() { return (jeInput ? qtyVal.value : qtyVal.textContent) || ''; }
    function pis(s) { if (jeInput) qtyVal.value = s; else qtyVal.textContent = s; }
    qtyVal.addEventListener('input', function () {
      /* pri písaní neorezávame na 999 — z „1000" by ticho vzniklo „100";
         necháme dopísať a zastropujeme až pri opustení poľa */
      var digits = citaj().replace(/[^0-9]/g, '').slice(0, 4);
      if (digits !== citaj()) pis(digits);
      var n = parseInt(digits, 10);
      if (n >= 1) { quantity = Math.min(999, n); qtyInput.value = quantity; }
    });
    qtyVal.addEventListener('change', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('blur', function () { setQty(parseInt(citaj(), 10) || 1); });
    qtyVal.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') { e.preventDefault(); qtyVal.blur(); }
    });
  })();

  // ── GALLERY refs (potrebné pre lightbox + fly-to-cart) ──
  const stage      = document.getElementById('lp-stage');
  const stageImgs  = stage ? Array.from(stage.querySelectorAll('.lp-stage__img')) : [];
  const thumbs     = document.querySelectorAll('.lp-thumb');
  const arrowPrev  = document.getElementById('lp-arrow-prev');
  const arrowNext  = document.getElementById('lp-arrow-next');
  const progressBar= document.getElementById('lp-mobile-progress-bar');
  let currentIdx   = 0;
  function activeStageImg() {
    return stageImgs.find(im => im.classList.contains('active')) || mainImgEl;
  }

  // ── FLY-TO-CART ──
  function flyToCart(fromEl) {
    try {
      let cart = null;
      const sels = ['.cart-drawer__button', '.header-actions__action', '#cart-icon-bubble',
                    '.cart-count-bubble', 'a[href$="/cart"]', 'a[href="/cart"]'];
      for (const s of sels) {
        const els = document.querySelectorAll(s);
        for (const el of els) {
          const r = el.getBoundingClientRect();
          if (r.width > 0 && r.height > 0 && r.top < 200 && r.left > window.innerWidth / 2) { cart = el; break; }
        }
        if (cart) break;
      }
      if (!cart || !fromEl) return;
      const s = fromEl.getBoundingClientRect();
      const e = cart.getBoundingClientRect();
      const fly = document.createElement('img');
      const act = activeStageImg();
      fly.src = (act && act.src) ? act.src : (mainImgEl ? mainImgEl.src : '');
      fly.style.cssText =
        'position:fixed;z-index:99999;pointer-events:none;object-fit:cover;border-radius:12px;' +
        'box-shadow:0 10px 30px rgba(0,0,0,.35);width:90px;height:90px;' +
        'left:' + (s.left + s.width/2 - 45) + 'px;top:' + (s.top + s.height/2 - 45) + 'px;' +
        'transition:left .85s cubic-bezier(.5,-0.25,.7,1),top .85s cubic-bezier(.5,-0.25,.7,1),' +
        'width .85s ease,height .85s ease,opacity .85s ease,transform .85s ease;';
      document.body.appendChild(fly);
      requestAnimationFrame(() => {
        fly.style.left = (e.left + e.width/2 - 14) + 'px';
        fly.style.top  = (e.top + e.height/2 - 14) + 'px';
        fly.style.width = '28px';
        fly.style.height = '28px';
        fly.style.opacity = '.35';
        fly.style.transform = 'rotate(22deg)';
      });
      setTimeout(() => {
        fly.remove();
        if (cart) { cart.style.transition = 'transform .3s cubic-bezier(.34,1.6,.64,1)'; cart.style.transform = 'scale(1.25)'; setTimeout(() => cart.style.transform = '', 320); }
      }, 880);
    } catch (err) {}
  }

  const CART_ICON  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>';
  const CHECK_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polyline points="20 6 9 17 4 12"/></svg>';

  // ── ADD TO CART (AJAX) ──
  if (heroForm && addBtn) {
    heroForm.addEventListener('submit', function(e) {
      e.preventDefault();
      if (!lpCurrentVid()) return;
      addBtn.classList.add('loading'); addBtn.disabled = true;
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: lpCurrentVid(), quantity: quantity}) })
      .then(r => r.json().then(data => ({ ok: r.ok, data })))
      .then(({ ok }) => {
        addBtn.classList.remove('loading');
        if (!ok) { addBtn.disabled = false; return; }
        flyToCart(addBtn);
        addBtn.classList.add('success');
        addBtn.querySelector('.lp-btn-cart-text').innerHTML = CHECK_ICON + ' Aggiunto al carrello!';
        setTimeout(() => {
          addBtn.classList.remove('success'); addBtn.disabled = false;
          addBtn.querySelector('.lp-btn-cart-text').innerHTML = CART_ICON + ' Aggiungi al carrello';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        }, 2200);
      })
      .catch(() => { addBtn.classList.remove('loading'); addBtn.disabled = false; });
    });
  }

  // ── BUY NOW (priamo na checkout) ──
  if (buyBtn) {
    buyBtn.addEventListener('click', function() {
      if (!lpCurrentVid()) return;
      buyBtn.disabled = true;
      buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="animation:lp-spin .7s linear infinite;width:16px;height:16px"><circle cx="12" cy="12" r="10" opacity=".25"/><path d="M22 12a10 10 0 0 1-10 10"/></svg> ...';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: lpCurrentVid(), quantity: quantity}) })
      .then(r => {
        if (!r.ok) {
          buyBtn.disabled = false;
          buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Acquista ora';
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(() => { buyBtn.disabled = false; buyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" style="flex-shrink:0;min-width:17px;width:17px;height:17px"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg> Acquista ora'; });
    });
  }

  // ── STICKY BAR (zobraz až keď buyBtn vyscrollne nahor) ──
  let stickyTicking = false;
  function injectChatShadowStyle(css) {
    const root = document.getElementById('artmie-chatbot-root');
    if (!root || !root.shadowRoot) return false;
    let s = root.shadowRoot.querySelector('style[data-lp-injected]');
    if (!s) { s = document.createElement('style'); s.setAttribute('data-lp-injected', '1'); root.shadowRoot.appendChild(s); }
    s.textContent = css;
    return true;
  }
  function updateChatOffset(show) {
    if (!window.matchMedia('(max-width: 768px)').matches) {
      injectChatShadowStyle(':host { transform: none !important; }');
      const r = document.getElementById('artmie-chatbot-root');
      if (r) r.style.removeProperty('transform');
      return;
    }
    const css = show
      ? ':host { transform: translateY(-72px) !important; transition: transform .25s ease !important; }'
      : ':host { transform: none !important; transition: transform .25s ease !important; }';
    injectChatShadowStyle(css);
    const root = document.getElementById('artmie-chatbot-root');
    if (root) {
      root.style.transition = 'transform .25s ease';
      if (show) root.style.setProperty('transform', 'translateY(-72px)', 'important');
      else root.style.removeProperty('transform');
    }
  }
  function updateSticky() {
    if (!buyBtn || !stickyBar) { stickyTicking = false; return; }
    const rect = buyBtn.getBoundingClientRect();
    const show = rect.bottom < 0;
    stickyBar.classList.toggle('show', show);
    document.body.classList.toggle('lp-has-sticky', show);
    updateChatOffset(show);
    stickyTicking = false;
  }
  (function watchChatRoot(){
    if (document.getElementById('artmie-chatbot-root')) { updateChatOffset(document.body.classList.contains('lp-has-sticky')); return; }
    const mo = new MutationObserver(() => {
      if (document.getElementById('artmie-chatbot-root')) {
        mo.disconnect();
        updateChatOffset(document.body.classList.contains('lp-has-sticky'));
      }
    });
    mo.observe(document.body, { childList: true });
    setTimeout(() => mo.disconnect(), 30000);
  })();
  window.addEventListener('scroll', () => {
    if (!stickyTicking) { requestAnimationFrame(updateSticky); stickyTicking = true; }
  }, { passive: true });
  updateSticky();

  // ── STICKY BAR — add to cart ──
  if (stickyBtn) {
    stickyBtn.addEventListener('click', () => {
      if (!lpCurrentVid()) return;
      const original = stickyBtn.innerHTML;
      stickyBtn.disabled = true;
      stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="animation:lp-spin .7s linear infinite;width:16px;height:16px"><circle cx="12" cy="12" r="10" opacity=".25"/><path d="M22 12a10 10 0 0 1-10 10"/></svg><span>...</span>';
      fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id: lpCurrentVid(), quantity: quantity}) })
        .then(r => ({ ok: r.ok }))
        .then(({ ok }) => {
          if (!ok) { stickyBtn.innerHTML = original; stickyBtn.disabled = false; return; }
          flyToCart(stickyBtn);
          stickyBtn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" style="width:16px;height:16px"><polyline points="20 6 9 17 4 12"/></svg><span>W koszyku!</span>';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          setTimeout(() => { stickyBtn.innerHTML = original; stickyBtn.disabled = false; }, 2000);
        })
        .catch(() => { stickyBtn.innerHTML = original; stickyBtn.disabled = false; });
    });
  }

  // ── REELS — lazy load video ──
  const reels = document.querySelectorAll('.lp-reel');
  reels.forEach(reel => {
    const src = reel.dataset.src;
    const soundBtn = reel.querySelector('.lp-reel__sound');
    const soundOn  = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><path d="M15.54 8.46a5 5 0 0 1 0 7.07"/><path d="M19.07 4.93a10 10 0 0 1 0 14.14"/></svg>';
    const soundOff = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"/><line x1="23" y1="9" x2="17" y2="15"/><line x1="17" y1="9" x2="23" y2="15"/></svg>';
    let video = null;
    if (!src || src.length === 0) { reel.style.cursor = 'default'; return; }
    function ensureVideo() {
      if (video) return video;
      const poster = reel.querySelector('img');
      video = document.createElement('video');
      video.src = src; video.muted = true; video.loop = true; video.playsInline = true;
      video.setAttribute('webkit-playsinline', '');
      video.preload = 'none';
      if (poster) video.poster = poster.src;
      reel.replaceChild(video, poster);
      new IntersectionObserver(entries => {
        entries.forEach(e => { if (!e.isIntersecting && !video.paused) video.pause(); });
      }, { threshold: 0.2 }).observe(reel);
      video.addEventListener('play', () => reel.classList.add('playing'));
      video.addEventListener('pause', () => reel.classList.remove('playing'));
      return video;
    }
    reel.addEventListener('click', (ev) => {
      if (ev.target.closest('.lp-reel__sound')) return;
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {}); else v.pause();
    });
    if (soundBtn) soundBtn.addEventListener('click', (ev) => {
      ev.stopPropagation();
      const v = ensureVideo();
      if (v.paused) v.play().catch(() => {});
      v.muted = !v.muted;
      soundBtn.innerHTML = v.muted ? soundOff : soundOn;
    });
  });

  // ── GALÉRIA — thumb nav arrows ──
  const thumbsBox = document.getElementById('lp-thumbs');
  const thumbUp   = document.getElementById('lp-thumb-up');
  const thumbDown = document.getElementById('lp-thumb-down');
  if (thumbsBox && thumbUp && thumbDown) {
    const STEP = 204;
    function updateThumbNav() {
      const scrollable = thumbsBox.scrollHeight > thumbsBox.clientHeight + 2;
      const atTop = thumbsBox.scrollTop <= 2;
      const atBottom = thumbsBox.scrollTop + thumbsBox.clientHeight >= thumbsBox.scrollHeight - 2;
      thumbUp.hidden = !scrollable || atTop;
      thumbDown.hidden = !scrollable || atBottom;
    }
    thumbUp.addEventListener('click', () => thumbsBox.scrollBy({ top: -STEP, behavior: 'smooth' }));
    thumbDown.addEventListener('click', () => thumbsBox.scrollBy({ top: STEP, behavior: 'smooth' }));
    thumbsBox.addEventListener('scroll', updateThumbNav, { passive: true });
    window.addEventListener('resize', updateThumbNav);
    updateThumbNav();
  }

  // ── GALÉRIA — cross-slide ──
  function updateGalleryControls(idx) {
    if (arrowPrev) arrowPrev.toggleAttribute('disabled', false);
    if (arrowNext) arrowNext.toggleAttribute('disabled', false);
    if (progressBar && thumbs.length) {
      const n = (stageImgs && stageImgs.length) ? stageImgs.length : thumbs.length;
      if (n > 0) {
        progressBar.style.width = (100 / n) + '%';
        progressBar.style.transform = 'translateX(' + (idx * 100) + '%)';
      }
    }
  }
  let slideBusy = false;
  window.lpGoToSlide = function (i, d) { return goToThumb(i, d); };
  function goToThumb(idx, dir) {
    if (idx < 0 || idx >= stageImgs.length) return;
    if (idx === currentIdx) {
      thumbs.forEach(x => x.classList.remove('active'));
      if (thumbs[idx]) thumbs[idx].classList.add('active');
      updateGalleryControls(idx);
      return;
    }
    if (slideBusy) return;
    if (!dir) dir = idx > currentIdx ? 'next' : 'prev';
    const oldImg = stageImgs[currentIdx];
    const newImg = stageImgs[idx];
    const prepClass = dir === 'next' ? 'prep-right' : 'prep-left';
    newImg.classList.remove('active','out-left','out-right','prep-left','prep-right');
    newImg.classList.add(prepClass);
    void newImg.offsetWidth;
    slideBusy = true;
    requestAnimationFrame(() => {
      newImg.classList.remove(prepClass);
      newImg.classList.add('active');
      oldImg.classList.remove('active');
      oldImg.classList.add(dir === 'next' ? 'out-left' : 'out-right');
    });
    setTimeout(() => {
      stageImgs.forEach((im, i) => {
        if (i !== idx) {
          im.classList.remove('active','out-left','out-right','prep-left');
          im.classList.add('prep-right');
        }
      });
      slideBusy = false;
    }, 460);
    currentIdx = idx;
    thumbs.forEach(x => x.classList.remove('active'));
    if (thumbs[idx]) thumbs[idx].classList.add('active');
    updateGalleryControls(idx);
    try { if (thumbs[idx]) thumbs[idx].scrollIntoView({ behavior:'smooth', block:'nearest', inline:'nearest' }); } catch(e){}
  }
  thumbs.forEach((t, idx) => { t.addEventListener('click', () => goToThumb(idx)); });
  function currentThumbIdx(){
    let i = 0;
    thumbs.forEach((t, k) => { if (t.classList.contains('active')) i = k; });
    return i;
  }
  if (arrowPrev) arrowPrev.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i - 1 + thumbs.length) % thumbs.length;
    goToThumb(next, 'prev');
  });
  if (arrowNext) arrowNext.addEventListener('click', () => {
    const i = currentThumbIdx();
    const next = (i + 1) % thumbs.length;
    goToThumb(next, 'next');
  });
  updateGalleryControls(0);

  // ── SWIPE na hlavnej fotke ──
  (function(){
    if (!stage) return;
    let sx = 0, sy = 0, sw = false;
    function start(e){ const t = e.touches ? e.touches[0] : e; sx = t.clientX; sy = t.clientY; sw = true; }
    function end(e){
      if (!sw) return; sw = false;
      const t = e.changedTouches ? e.changedTouches[0] : e;
      const dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
      const i = currentIdx, n = thumbs.length;
      if (n < 2) return;
      if (dx < 0)      goToThumb((i + 1) % n, 'next');
      else if (dx > 0) goToThumb((i - 1 + n) % n, 'prev');
    }
    stage.addEventListener('touchstart', start, { passive: true });
    stage.addEventListener('touchend',   end,   { passive: true });
  })();

  // ── FAQ accordion ──
  document.querySelectorAll('.lp-faq__item .lp-faq__q').forEach(function(btn, i){
    var item = btn.closest('.lp-faq__item');
    var ans  = item ? item.querySelector('.lp-faq__a') : null;
    if (ans) {                                   // ARIA väzba otázka ↔ odpoveď pre čítačky
      if (!ans.id) ans.id = 'lp-faq-a-' + i;
      if (!btn.id) btn.id = 'lp-faq-q-' + i;
      ans.setAttribute('role', 'region');
      ans.setAttribute('aria-labelledby', btn.id);
      btn.setAttribute('aria-controls', ans.id);
    }
    btn.setAttribute('aria-expanded', item && item.classList.contains('open') ? 'true' : 'false');
    btn.addEventListener('click', function(){
      var open = item.classList.toggle('open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  });

  // ── SECTION TABS — smooth scroll + active ──
  (function(){
    const tabs = document.querySelectorAll('.lp-tab');
    if (!tabs.length) return;
    const targets = Array.from(tabs).map(t => ({ tab: t, id: t.dataset.target, el: document.getElementById(t.dataset.target) })).filter(x => x.el);
    tabs.forEach(t => {
      t.addEventListener('click', (e) => {
        e.preventDefault();
        const id = t.dataset.target;
        const el = document.getElementById(id);
        if (!el) return;
        const rect = el.getBoundingClientRect();
        const top = rect.top + window.pageYOffset - 20;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
    // offsetTop meriame len pri resize/load — predtým to bol vynútený reflow v každom scroll frame
    let tops = targets.map(t => t.el.offsetTop);
    function measureTops() { tops = targets.map(t => t.el.offsetTop); }
    window.addEventListener('resize', measureTops);
    window.addEventListener('load', measureTops);
    function updateActive() {
      const mid = window.scrollY + window.innerHeight * 0.30;
      let active = targets[0];
      for (let i = 0; i < targets.length; i++) { if (tops[i] <= mid) active = targets[i]; }
      tabs.forEach(x => x.classList.toggle('active', x === active.tab));
    }
    let tick = false;
    window.addEventListener('scroll', () => {
      if (!tick) { requestAnimationFrame(() => { updateActive(); tick = false; }); tick = true; }
    }, { passive: true });
    updateActive();
  })();

  // ── LIGHTBOX ──
  const lightbox      = document.getElementById('lp-lightbox');
  const lightboxImg   = document.getElementById('lp-lightbox-img');
  const lightboxClose = document.getElementById('lp-lightbox-close');
  if (lightbox && lightboxImg && stage) {
    let sxL = 0, syL = 0;
    stage.addEventListener('touchstart', e => { const t = e.touches[0]; sxL = t.clientX; syL = t.clientY; }, { passive: true });
    function openLightbox(e) {
      if (e && e.changedTouches) {
        const t = e.changedTouches[0];
        if (Math.abs(t.clientX - sxL) > 10 || Math.abs(t.clientY - syL) > 10) return;
      }
      const act = activeStageImg();
      lightboxImg.src = act ? act.src : '';
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
      if (lightboxClose) lightboxClose.focus();
    }
    function closeLightbox() {
      if (!lightbox.classList.contains('open')) return;
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
      stage.focus();
    }
    // klávesnica: galéria sa dá otvoriť Enterom/medzerníkom, fokus sa po zatvorení vráti
    stage.setAttribute('tabindex', '0');
    stage.setAttribute('role', 'button');
    if (mainImgEl && mainImgEl.alt) stage.setAttribute('aria-label', mainImgEl.alt);
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    stage.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLightbox(); } });
    stage.addEventListener('click', openLightbox);
    lightbox.addEventListener('click', closeLightbox);
    if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLightbox(); });
  }
})();

/* == El Greco tube — kolor swatch + objem link picker (live variant, §6.9) == */
(function(){
  var swatches=document.querySelectorAll('.lp-swatch'); if(!swatches.length) return;
  var vidInput=document.getElementById('lp-variant-id');
  var priceEl=document.getElementById('lp-price');
  var oldEl=document.querySelector('.lp-price-row .lp-price-old');
  var nameEl=document.getElementById('lp-swatch-name');
  var skuEl=document.getElementById('lp-sku-internal');
  var mainImg=document.getElementById('lp-main-img');
  var bigImg=document.getElementById('lp-swatch-big-img');
  var trigImg=document.getElementById('lp-swatch-trigger-img');
  var trigName=document.getElementById('lp-swatch-trigger-name');
  var curPricePill=document.getElementById('lp-volpill-current-price');
  var other=document.getElementById('lp-vol-other');
  var otherPrice=document.getElementById('lp-volpill-other-price');
  var otherNa=document.getElementById('lp-volpill-other-na');
  var stickyColor=document.getElementById('lp-sticky-color');
  var stickyWrap=document.getElementById('lp-sticky-price');
  var otherData=null;
  try{ otherData=JSON.parse(document.getElementById('lp-other-map').textContent); }catch(e){}
  function syncOther(key){
    if(!other||!otherData) return;
    var m=otherData.map[key];
    if(m&&m.avail){
      other.classList.remove('lp-volc--disabled');
      other.setAttribute('href', otherData.url+'?variant='+m.id);
      if(otherPrice){ otherPrice.textContent=m.price; otherPrice.hidden=false; }
      if(otherNa) otherNa.hidden=true;
    } else {
      other.classList.add('lp-volc--disabled');
      other.removeAttribute('href');
      if(otherPrice){ otherPrice.textContent=''; otherPrice.hidden=true; }
      if(otherNa) otherNa.hidden=false;
    }
  }
  function apply(btn){
    if(btn.dataset.avail==='0') return;
    swatches.forEach(function(b){ b.classList.remove('lp-swatch--active'); b.setAttribute('aria-selected','false'); });
    btn.classList.add('lp-swatch--active'); btn.setAttribute('aria-selected','true');
    if(vidInput) vidInput.value=btn.dataset.vid;
    if(priceEl) priceEl.textContent=btn.dataset.price;
    if(curPricePill) curPricePill.textContent=btn.dataset.price;
    if(oldEl){ if(btn.dataset.compare){ oldEl.textContent=btn.dataset.compare; oldEl.classList.add('show'); oldEl.style.display=''; } else { oldEl.classList.remove('show'); oldEl.style.display='none'; oldEl.textContent=''; } }
    if(nameEl) nameEl.textContent=btn.dataset.title;
    if(stickyColor) stickyColor.textContent=btn.dataset.title;
    if(skuEl&&btn.dataset.sku) skuEl.textContent=btn.dataset.sku;
    if(stickyWrap){ var sp=stickyWrap.querySelector('span'); if(sp) sp.textContent=btn.dataset.price; var so=stickyWrap.querySelector('.lp-sticky__price-old'); if(so){ if(btn.dataset.compare){ so.textContent=btn.dataset.compare; so.style.display=''; } else { so.style.display='none'; } } }
    if(bigImg&&btn.dataset.img){ bigImg.src=btn.dataset.img; }
    if(trigImg&&btn.dataset.img){ trigImg.src=btn.dataset.img; }
    if(trigName) trigName.textContent=btn.dataset.title;
    // Galéria: prepni na slajd toho variantu. Prepisovať src aktívneho slajdu sa nesmie —
    // natrvalo by prepísalo cudziu fotku a dva slajdy by ukazovali to isté.
    var _si = parseInt(btn.dataset.slide, 10);
    if(!isNaN(_si) && typeof window.lpGoToSlide==='function'){
      window.lpGoToSlide(_si);
      // ak práve dobieha iná animácia, galéria klik zahodí — skús ešte raz
      setTimeout(function(){
        var st=document.querySelectorAll('.lp-stage__img');
        if(st[_si] && !st[_si].classList.contains('active')) window.lpGoToSlide(_si);
      }, 520);
    } else if(btn.dataset.img){
      var activeStage=document.querySelector('.lp-stage__img.active');
      if(activeStage){ activeStage.removeAttribute('srcset'); activeStage.src=btn.dataset.img; }
      if(mainImg&&mainImg!==activeStage){ mainImg.removeAttribute('srcset'); mainImg.src=btn.dataset.img; }
    }
    syncOther(btn.dataset.key);
    try{ var u=new URL(window.location.href); u.searchParams.set('variant', btn.dataset.vid); window.history.replaceState({},'',u.toString()); }catch(e){}
    closeSheet();
  }
  // ── panel odtieňov: „Wybierz kolor" → desktop dropdown / mobil spodný sheet ──
  var trigger=document.getElementById('lp-swatch-trigger');
  var backdrop=document.getElementById('lp-swatch-backdrop');
  var closeBtn=document.getElementById('lp-swatch-close');
  var field=document.querySelector('.lp-swatch-field');
  function isOpen(){ return document.body.classList.contains('lp-sheet-open'); }
  function openSheet(){ document.body.classList.add('lp-sheet-open'); if(trigger) trigger.setAttribute('aria-expanded','true'); }
  function closeSheet(){ document.body.classList.remove('lp-sheet-open'); if(trigger) trigger.setAttribute('aria-expanded','false'); }
  if(trigger) trigger.addEventListener('click', function(e){ e.stopPropagation(); if(isOpen()) closeSheet(); else openSheet(); });
  if(backdrop) backdrop.addEventListener('click', closeSheet);
  if(closeBtn) closeBtn.addEventListener('click', closeSheet);
  window.addEventListener('keydown', function(e){ if(e.key==='Escape') closeSheet(); });
  // klik mimo panela (desktop dropdown) → zavri
  document.addEventListener('click', function(e){ if(isOpen() && field && !field.contains(e.target)) closeSheet(); });
  swatches.forEach(function(btn){ btn.addEventListener('click',function(){ apply(btn); }); });
  var act=document.querySelector('.lp-swatch--active')||swatches[0];
  if(act) syncOther(act.dataset.key);
})();

/* == El Greco tube — swipe indikátor: ukáž len keď je čo swipnúť, skry na konci == */
(function(){
  var sw=document.querySelector('.lp-swatches'); var hint=document.querySelector('.lp-swatches-swipe');
  if(!sw||!hint) return;
  function upd(){
    // horizontálny swipe je len na mobile; ak niet overflow alebo sme na konci → skry
    var overflow = sw.scrollWidth - sw.clientWidth;
    var atEnd = sw.scrollLeft >= overflow - 6;
    hint.style.display = (overflow <= 6 || atEnd) ? 'none' : '';
  }
  sw.addEventListener('scroll', upd, {passive:true});
  window.addEventListener('resize', upd);
  if(window.ResizeObserver){ try{ new ResizeObserver(upd).observe(sw); }catch(e){} }
  setTimeout(upd, 250); setTimeout(upd, 900);
})();


